import React from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const AffiliateDetails = () => {
    return (
        <div className="p-4" style={{ borderRadius: "6px"}}>
            <h3 className="fw-bold mb-3">🌍 Become a PWU Affiliate Partner</h3>

            <p>Unlock the opportunity to earn high commissions by promoting world-class business, income, and personal growth programs. </p>

            {/* <h6 className="fw-bold mt-4">How the Affiliate Program Works</h6> */}
            <p>
                At Passionate World University (PWU), we empower people through premium education, consulting, and transformational training. Now, you can become a part of that mission—and earn commission per sale by referring clients to our flagship programs.
            </p>
            <p>
                We are looking for passionate educators, influencers, marketers, creators, and community builders who want to generate income by sharing value. Whether you have a large audience or are just starting out, if you're aligned with our values and vision, we want to hear from you.
            </p>

            <h6 className="fw-bold mt-4"> PWU Affiliate Outcomes</h6>
            
            <p>
                1. Earn commission per sale ( Commission Ratio Depends on Mutual Agreement) 
            </p>
            <p>
                2. Earn 10,000–1,00,000+ BDT per referral Promote high-ticket PWU programs with huge payout potential.
            </p>
            <p>
                3. Get Monthly payouts—every 40 days Receive your commission directly to your bank account. 
            </p>
            <p>
                4. Access 50+ pre-built marketing creatives Includes images, captions, landing pages, emails, and video scripts.
            </p>
            <p>
                5. Get Monthly Consulting Access With Jahid Hasan (12x per year)Learn from Jahid to Improve your Life,Business & Income.
            </p>
            <p>
                6. Unlock cash bonuses or gift at 5, 10, and 20 sales milestones.
            </p>
            <p>
                7. Get Affiliate Dashboard with real-time tracking
            </p><br/>
            <p>
                Please fill out the form below to request access to our affiliate program. Our team will review your request and get back to you within 72 hours.
            </p>
            <p>
                <FiArrowRight />Let’s grow, impact, and earn—together.

            </p>
            

            {/* Buttons */}
            <div className="text-center mt-4">
                <button className="btn-default me-5"><Link to="/login">Login</Link></button>
                <button className="btn-default"><Link to="/signup">Join</Link></button>
            </div>
        </div>
    );
};

export default AffiliateDetails;
